import { api } from "../api";
import { CreditPickerControl } from "../components/credit-picker";
import { displayFormControl } from "../ui/alert";
import { runOperation } from "../ui/operation";

export function DisplayCreditAdditionModal() {
    displayFormControl({
        title: "Add credits",
        message: "Enter the amount you wish to add in credits to your account.",
        formControlItem: CreditPickerControl(),
        onConfirm(value) {
            runOperation("Creating payment link...", async () => {
                const response = await api.postJson("/api/v1/payments", value);
                window.open(response.data.location, "_blank", "noopener");
            });
        }
    })
}